import React from "react";
import ReactDOM from "react-dom";
import "./css/index.css";
import "./css/animate.css";
import "./assets/materialize/materialize.min.css";

import App from "./App";

ReactDOM.render(<App />, document.getElementById("root"));
